<template>
     <tbody>
         <tr v-for="(item, index) in itemList" :key="index" :class="item.name">
            <template v-if="item.type == 'component'">
                <td>
                    <img v-if="item.products[0].image.length" :src="'https://campbellsci-res.cloudinary.com/image/upload/w_50,h_50/'+ item.products[0].image + '.png'" />
                    <i v-else class="mi csi-iconfont csi-logo"></i>
                </td>
                <td>
                    <div class="cartListItem" :id="item.products[0].c_part">
                        <a class="itemName" target="_blank" :href="'/order/' + item.products[0].url">
                            {{ item.products[0].c_part }}
                        </a><br />
                        <span class="text-muted"><pre class="pre-unstyled">{{ item.products[0].title }}</pre></span>
                    </div>
                </td>
                <td>(<strong>{{ item.products[0].quantity * item.mainqty }}</strong>)</td>
            </template>

            <template v-else-if="item.type == 'sysconfig'">
                <td>
                    <img v-if="item.systemImage.length && item.systemImage[0].image > 0" :src="'https://campbellsci-res.cloudinary.com/image/upload/w_50,h_50/'+ item.systemImage[0].image + '.png'" />
                    <i v-else class="mi csi-iconfont csi-logo"></i>
                </td>
                <td>
                    <div class="cartListItem" :id="item.name">
                        <a class="itemName" target="_blank" :href="'/order/' + item.sysInfo.prod_url">
                            {{ item.sysInfo.prod_model }}
                        </a><br />
                        <span class="text-muted">{{ item.sysInfo.prod_title }}</span><br />
                        <!--- TODO Does this every need to show the pieces? -->
                        <small>
                            <div v-for="(product, index) in item.itemProdsSorted" :key="index" class="margintop5">
                                <template v-if="product.parent.length">
                                    &nbsp;&nbsp;&nbsp;-
                                </template>
                                <strong>{{ product.c_part }}</strong> - {{ product.title }} ({{ product.quantity }})
                            </div>
                        </small>
                    </div>
                </td>
                <td>(<strong>{{ item.mainqty }}</strong>)</td>
            </template>

            <template v-else-if="item.type == 'sysBuilder'">
                <td>
                    <i class="mi csi-iconfont csi-logo"></i>
                </td>
                <td>
                    <div class="cartListItem"  :id="item.name">
                        <a class="itemName" target="_blank" :href="pageURLs[829] + '?system='+ item.name">
                            {{ item.name }}
                        </a>

                        <div class="small">
                            <div v-for="(product, index) in item.itemProdsSorted" :key="index" class="margintop5">
                                <template v-if="product.parent.length">&nbsp;&nbsp;&nbsp;- </template>
                                <strong>{{ product.c_part }}</strong> {{ product.title }} ({{ product.quantity }})
                            </div>
                        </div>
                    </div>
                </td>
                <td>(<strong>{{ item.mainqty }}</strong>)</td>
            </template>
        <!--- TODO Check subscriptions -->
            <template v-else-if="item.type == 'subscription'">
                <td>
                    <img class="img-responsive" src="https://campbellsci-res.cloudinary.com/image/upload/w_50,h_50/11987.png" />
                </td>
                <td>
                    <div class="cartListItem"  id="#item.name#">
                        <a class="itemName" target="_blank" :href="'/' + pageURLs[93] + '?mode=celldata&view=renewals'">
                            {{ item.name }}
                        </a>

                        <div class="small">
                            <div v-for="(p, index) in item.products" :key="index" class="margintop5">
                                {{index + 1}}
                                {{ p.title }} ({{ p.quantity }})
                            </div>
                        </div>
                    </div>
                </td>
                <td>(<strong>{{ item.mainqty }}</strong>)</td>
            </template>
        </tr>
    </tbody>
</template>

<script>
import useCMS from "../../shared/composables/useCMS"

export default {
    name: 'CheckoutReviewItem',
    props: {
        itemList: Array
    },
    setup () {
        const { labels, pageURLs } = useCMS();

        return {
            labels,
            pageURLs
        }
    }
}
</script>
